import PoweredBy from './PoweredBy.js'
import AgentsAvatar from './AgentsAvatar.js'
import Time from '../components/Time.js'
import Header from './Header.js'
import Emoji from '../components/Emoji.js'
import store from '@sb/store'
var sb = require('@sb/util')
var send = require('../../assets/img/send.svg')
const browser = require('bowser').getParser(window.navigator.userAgent).parsedResult

export default {
	name: 'ConvoList',
	props: ['isShow'],
	data () {
		return {
			...store.bind(this, ['convoM', 'convoEventM', 'user', 'account', 'accountSetting']),
			defaultAvatar: 'https://filev4.subiz.com/fiqoahedjbgwclpouoml-avatar_default_baa8a1d7.png',
		}
	},

	mounted () {
		store.setLastview('list')
	},

	render () {
		var convos = sb.map(this.convoM, convo => convo)
		convos = sb.orderBy(sb.cloneDeep(convos), 'created', 'desc')
		var $convos = sb.map(convos, convo => {
			var agentids = sb.agentsOfConvo(convo)
			return (
				<div class="convo-list--item" vOn:click={() => this.go(convo._key)} key={convo._key}>
					<AgentsAvatar mode="member" class="d-flex flex-row" tooltipPos="right" agent_ids={agentids} />
					{this.renderConvoSummary(convo)}
				</div>
			)
		})

		let cls = 'widget-container '
		let position = sb.get(this.accountSetting, 'desktop_button.position') || 'right'
		if (browser.platform.type === 'mobile') position = sb.get(this.accountSetting, 'mobile_button.position') || position
		cls += ' widget-container--' + position
		cls += this.isShow ? '' : ' widget-container--hide'

		return (
			<div class={cls}>
				<div class="widget-header widget-header--convo-list-expanded">
					<Header hideBackButton={true} vOn:close={() => this.$emit('close')} mode="expanded" />
				</div>
				<div class="convo-list">
					<div class="convo-list--container">
						<div class="convo-list--title">{this.$t('conversations')}</div>
						<div class="convo-list--list">{$convos}</div>
					</div>
					<div class="convo-list--footer">
				<button class="btn--start-convo" vOn:click={this.onStartConvoClick}>
							<span>{this.$t('start_conversation')}</span>
							<img src={send} alt />
						</button>
						<PoweredBy />
					</div>
				</div>
			</div>
		)
	},

	methods: {
		async onStartConvoClick() {
			await store.fetchUserSetting()
			this.go('')
		},

		renderConvoSummary (convo) {
			var agents = this.agentsOfConvo(convo)
			var name = sb.each(agents, ag => ag.fullname).join(', ')
			if (!name) name = this.account.name
			if (!name) name = this.$t('agent')

			var $you = null
			if (convo.lastSenderType === 'user') {
				$you = <span class="yourmessage">{this.$t('you')}:</span>
			}

			var time = new Date(sb.getMs(convo.last_actived) || sb.getMs(convo.created))
			var $tim = <Time ago={true} time={time} key={new Date().getTime()} />

			var lastmsg = this.renderMessagePreview({ data: { message: sb.get(convo, 'last_message') } })
			return (
				<div class="convo-list--convo-last-info">
					<div class="d-flex flex-row">
						<div class="convo-list--convo-name">{name}</div>
						<div class="convo-list--convo-time">{$tim}</div>
					</div>

					<div class="d-flex flex-row">
						<div class="convo-list--convo-last-message">
							{$you}
							{lastmsg}
						</div>
						{this.renderUnread(convo)}
					</div>
				</div>
			)
		},

		renderUnread (convo) {
			let seen = sb.isConvoSeen(this.user.id, this.convoEventM[convo._key])
			if (seen) return null
			return <div class="convo-list--item-unread"></div>
		},

		go (key) {
			this.$emit('go', key)
		},

		agentsOfConvo (convo) {
			var agentids = sb.agentsOfConvo(convo)
			return sb.map(agentids, id => store.agentM[id] || { avatar_url: this.defaultAvatar, fullname: 'Offline Agent' })
		},

		renderMessagePreview (ev) {
			let defmsg = this.$t('sent_you_a_message')

			let message = sb.get(ev, 'data.message.text')
			var format = sb.get(ev, 'data.message.format')

			// cant display message
			if (format !== 'plaintext') message = defmsg
			if (!message && sb.size(sb.get(ev, 'data.message.attachments')) > 0) message = defmsg

			if (!message) return null
			let byType = sb.get(ev, 'by.type')
			return sb.map(sb.extractText(message), tag => {
				if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} byType={byType} />
				return tag.text
			})
		},
	},
}
